import bots from './bots'
import knowledgeBase from './knowledge-base'
import questionsAnswers from './questions-answers'

export default {
  state: {
    navigate: {
      activeSection: 'bots'
    },
    ...bots.state,
    ...knowledgeBase.state,
    ...questionsAnswers.state

  },
  getters: {
    ...bots.getters,
    ...knowledgeBase.getters,
    ...questionsAnswers.getters

  },
  mutations: {
    ...bots.mutations,
    ...knowledgeBase.mutations,
    ...questionsAnswers.mutations

  },
  actions: {
    ...bots.actions,
    ...knowledgeBase.actions,
    ...questionsAnswers.actions
  }
}
